<template>
    <div class="PDFChatItem">
      <div class="chat-time text-[#A1A3AE] text-[14px] mb-4 text-center" v-if="timeShow && PDFChatItem.time">
        - {{ PDFChatItem.time?.replace(/-/g,'.') }} -
      </div>
        <div class="chat-item mb-4">
            <div class="flex items-end justify-end" v-if="isUser">
              <div class="w-max py-4 pl-6 pr-6 bg-[#4C5BDF] text-white rounded-[10px] rounded-tr-none break-words" v-html="content"></div>
            </div>
            <div v-else class="py-4 pr-3 pl-6 bg-[#fff] text-[#333333] rounded-[10px] rounded-tl-none" v-html="content"></div>
        </div>
        <div class="more_btn w-full flex max-sm:px-4" :class="(isAssistant && !(isFetching && PDFChatItem.isLoading)) ? 'justify-end': ''">
            <div class="stop_btn" @click="$emit('handleClick', 'close')" v-if="isFetching && PDFChatItem.isLoading">
                <button>
                    <img class="w-[12px] h-[12px] mr-[5px]" src="@/assets/icon_stop.png" alt="">
                    停止生成
                </button>
            </div>
            <div v-if="isAssistant && !isFetching" class=" text-xs text-[#A1A3AE] pl-[10px] max-sm:ml-4 flex-1" >以上内容由AI生成，仅供参考</div>
            <div v-if="isAssistant && !isFetching" class="copy_btn max-sm:ml-4" v-clipboard:copy="tagContent" 
            v-clipboard:success="copySuccess" v-clipboard:error="copyError"
            >复制</div>
        </div>
        <div v-if="PDFChatItem.questions?.length" class=" mb-8 mt-5">
          <div class="questions_title">推荐问题</div>
          <p class="questions" v-for="(item) in PDFChatItem.questions" :key="item" @click="handleClick(item)">
            {{ item }}
          </p>
        </div>
    </div>
</template>

<script>
import { renderMarkdown, removeHtmlTags } from "@/utils/util";
export default {
    props: ['PDFChatItem', 'isFetching', 'timeShow'],
    data() {
        return {}
    },
    computed: {
        isUser() {
            return this.PDFChatItem.role === 'user'
        },
        isAssistant() {
            return this.PDFChatItem.role === 'assistant'
        },
        content() {
          console.log(this.PDFChatItem);
            let content =  this.PDFChatItem.content ? this.PDFChatItem.content : '';
            if (content.length <= 0) {
              return '<span class="generating"></span>';
            }
            // if (this.PDFChatItem.isLoading && content.length <= 0) { // 生成中...
            //     return '<span class="generating"></span>';
            // }
            // if (this.PDFChatItem.isLoading) { // loading 加载中
            //     content += '<span class="typing blinker"></span>';
            // }
            return renderMarkdown(content);
        },
        tagContent() {
           let content = this.PDFChatItem.content ? this.PDFChatItem.content : '';
          //  return removeHtmlTags(content);
           return content;
        }
    },
    methods: {
      copySuccess (e) {
        // this.$message.success('复制成功！')
        this.$message({
          message: '复制成功！',
          type: 'success',
          center: true
        });
      },
      // 复制失败
      copyError (e) {
        // this.$message.error('复制失败！')
        this.$message({
          message: '复制失败！',
          type: 'error',
          center: true
        });
      },
      // pdf解析后推荐问题点击回调
      handleClick(item) {
        console.log(item);
        this.$bus.$emit('recommendedQuestion', item)
      }
    }
}
</script>

<style lang="scss" scoped>
.PDFChatItem{
    @apply  shrink-0 h-full flex-1 overflow-hidden break-words;
}
:deep(.typing::after) {
  content: '▌';
}
// 光标闪烁动画
:deep(.blinker::after) {
  animation: blinker 1s step-end infinite;
}
@keyframes blinker {
  0% {
    visibility: visible;
  }
  50% {
    visibility: hidden;
  }
  100% {
    visibility: visible;
  }
}

:deep(.generating) {
  font-size: 16px;
  color: var(--text-gray-color);
  &::after {
    content: '生成中';
    animation: generating 3s infinite;
  }
}
@keyframes generating {
  0% {
    content: '生成中';
  }
  25% {
    content: '生成中.';
  }
  50% {
    content: '生成中..';
  }
  75% {
    content: '生成中...';
  }
}
.more_btn {
	@apply flex flex-row items-center my-[8px];
	.stop_btn {
		@apply max-sm:hidden mr-6 cursor-pointer text-xs text-[#A1A3AE];
		button {
			@apply bg-white justify-center rounded-[4px] flex items-center h-[28px] w-[88px];
		}
	}
  .ai_answer_tip{
    @apply text-sm text-[#A0A3AE];
  }
	.copy_btn {
		@apply text-xs text-[#A1A3AE] pl-[22px] cursor-pointer;
		background: url('@/assets/icon_copy.png') no-repeat;
		background-size: 14px 14px;
	}
}

.questions_title{
  @apply pl-6 mb-2;
  background: url('@/assets/icon_01.png') no-repeat left center;
  background-size: 18px 18px;
}
.questions{
  @apply  pr-3 pl-6 text-[#4075EA]  mb-2 cursor-pointer;
  text-decoration: underline;
  background: url('@/assets/icon_02.png') no-repeat left center;
  background-size: 18px 18px;
}

</style>